import { FC } from 'react';
// Store
import { useAppDispatch } from 'app/hooks/useStore';
// Async
import { getStats, getMonthlyStats } from 'app/store/Analytics/Analytics.async';
// Mui
import { Box, Divider, Container, Paper } from '@mui/material';
// Components
import { AnalyticsStats, AnalyticsMonthlyStats } from 'app/components/Analytics';
// i18next
import { useTranslation } from 'react-i18next';

const UsageReportTabContent:FC = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();

  const handleGetAccountStats = () => {
    dispatch(getStats({}));
  }

  const handleGetAccountMonhtlyStats = (params:any) => {
    dispatch(getMonthlyStats(params));
  }

  return (
    <Box sx={{ flexGrow: 1, overflowY: 'auto' }} react-action="scroll">
      <Container sx={{ py: 4 }} maxWidth="md">
        <Paper sx={{ p: 4 }}>
          <AnalyticsStats
            title={t('pages.analytics.allAccountsTotals')}
            onGetStats={handleGetAccountStats}
          />
          <Divider sx={{ my: 4 }} />
          <AnalyticsMonthlyStats onGetMonthlyStats={handleGetAccountMonhtlyStats} />
        </Paper>
      </Container>
    </Box>
  )
}

export default UsageReportTabContent;
